<template>
<div id="app">
    <Navbar/>
    <main>
        <router-view/>
    </main>
    <ClaimBar/>
    <Footer/>
    </div>
</template>
<script>
import Navbar from '@/components/layout/Navbar.vue';  
import Footer from '@/components/layout/Footer.vue'; 
import ClaimBar from '@/components/ClaimBar.vue'; 
export default { 
    name:'App', 
    components:{Navbar,Footer, ClaimBar} 
}
</script>
